import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Icons } from 'shared/components/ui/Icons';
import { navData } from 'localData/navData';
import { getActiveGameIsRandom } from 'pages/RockPaperScissors/plays/model/selectors/getGamesData';
import './Navigation.scss';

type TNavigationItem = {
  id: number;
  url: string;
  name: string;
  icon: string;
  disabled: boolean;
};

export const Navigation = () => {
  const isRandom = useSelector(getActiveGameIsRandom);

  return (
    <nav className="navigation navigation--game">
      <div className="container">
        <ul className="navigation__list">
          {navData.map((item: TNavigationItem) => {
            if (item.disabled) return null;
            return (
              <li
                key={item.id}
                className={`navigation__item${
                  item.disabled ? ' disabled' : ''
                }`}
              >
                <NavLink
                  to={item.url}
                  title={item.name}
                  className={`navigation__link${isRandom ? ' disabled' : ''}`}
                >
                  <Icons name={item.icon} />
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};
